import {HTMLProps} from 'react';
import Button from './Button';

interface IProps extends HTMLProps<HTMLDivElement> {
  isActive: boolean;
  disabled?: boolean;
  leftLabel: string;
  rightLabel: string;
  onClickLeft: () => void;
  onClickRight: () => void;
}

export default function FloatingDevToggle({
  isActive,
  disabled,
  leftLabel,
  rightLabel,
  onClickLeft,
  onClickRight,
  className,
  ...rest
}: IProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between',
        'rounded-28 overflow-hidden relative',
        'relative bg-white',
        className,
        {
          'opacity-40': disabled,
        }
      )}
      {...rest}
    >
      <div
        className={cn(
          'absolute left-0 top-0 rounded-28',
          'w-1/2 h-full bg-red',
          'pointer-events-none',
          'transition-transform',
          {
            'translate-x-0': isActive,
            'translate-x-full': !isActive,
          }
        )}
      />
      <Button
        className={cn('flex-auto h-full px-15 py-10 relative', {
          's14-regular-white': isActive,
          's14-regular-black': !isActive,
        })}
        disabled={disabled}
        onClick={onClickLeft}
      >
        {leftLabel}
      </Button>
      <Button
        className={cn('flex-auto h-full px-15 py-10 relative', {
          's14-regular-white': !isActive,
          's14-regular-black': isActive,
        })}
        disabled={disabled}
        onClick={onClickRight}
      >
        {rightLabel}
      </Button>
    </div>
  );
}
